import { FontFamilyItem } from '@progress/kendo-angular-editor';

export const editorFontFamilies = new Array<FontFamilyItem>(
  { text: 'Arial', fontName: 'arial' },
  { text: 'Calibri', fontName: 'calibriregular, sans-serif' },
  { text: 'Calibri Light', fontName: 'calibrilight, sans-serif' },
  { text: 'Poppins', fontName: 'poppins, sans-serif' },
);
